import { render } from "./TardyRadioGroup.vue?vue&type=template&id=184e493a&scoped=true"
import script from "./TardyRadioGroup.vue?vue&type=script&lang=js"
export * from "./TardyRadioGroup.vue?vue&type=script&lang=js"

import "./TardyRadioGroup.vue?vue&type=style&index=0&id=184e493a&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-184e493a"]])

export default __exports__